export default "__VITE_ASSET__CCHjJgUF__"